<div class="w-full lg:max-w-7xl p-8">
    <div class="prose prose-sm !max-w-100">
        <h2>Aðgreining úrskurða</h2>
        <h3>Hér færð þú yfirlit yfir aðgreiningu úrskurða í A-deild</h3>
    </div>
    <mat-divider class="my-4"></mat-divider>

    <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-6 px-0 !pt-1 mb-2">
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <div class="flex flex-col items-center mt-4 sm:flex-row">
                <div class="flex-auto w-[100%] sm:w-auto">
                    <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[90%] top-[5px] mb-1">
                        <mat-select placeholder="Staða" formControlName="divisionOfRulingStatus">
                            <mat-option [value]="null">{{'label_all' | translate }}</mat-option>
                            <ng-container *ngFor="let status of rulingStatusDropDown">
                                <mat-option [value]="status.value">{{status.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[90%] top-[15px] mb-1">
                        <span matPrefix>Dagsetning úrskurðar (frá):</span>
                        <input class="date" formControlName="dateFrom" matInput (click)="dateFrom.open()"
                            [matDatepicker]="dateFrom">
                        <mat-datepicker-toggle matSuffix [for]="dateFrom"></mat-datepicker-toggle>
                        <mat-datepicker #dateFrom></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[90%] top-[25px] mb-1">
                        <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                        <input formControlName="searchString" matInput [placeholder]="'Leita'"
                            (keydown.enter)="pageNumber = 0; fetchData()">
                    </mat-form-field>
                </div>

                <div class="flex-auto w-[100%] sm:w-auto mt-[10px] sm:mt-[0px]">
                    <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[100%] top-[5px] mb-1">
                        <mat-select placeholder="Hlutfall" formControlName="ratio">
                            <mat-option [value]="null">{{'label_all' | translate }}</mat-option>
                            <ng-container *ngFor="let table of ratioDropDown">
                                <mat-option [value]="table.value">{{table.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[100%] top-[15px] mb-1">
                        <span class="mr-[18px]" matPrefix>Dagsetning úrskurðar (til):</span>
                        <input class="date" formControlName="dateTo" matInput (click)="dateTo.open()"
                            [matDatepicker]="dateTo">
                        <mat-datepicker-toggle matSuffix [for]="dateTo"></mat-datepicker-toggle>
                        <mat-datepicker #dateTo></mat-datepicker>
                        <mat-error *ngIf="this.form?.get('dateTo')?.hasError('required')"> Það <strong>þarf</strong> að
                            velja dagsetningu </mat-error>
                    </mat-form-field>
                    <mat-form-field class="fuse-mat-no-subscript w-[100%] sm:w-[100%] top-[25px] mb-1">
                        <mat-select placeholder="Tegund úrskurðar" formControlName="paymentTransactionType">
                            <mat-option [value]="null">{{'label_all' | translate }}</mat-option>
                            <ng-container *ngFor="let table of paymentTransactionTypeDropDown">
                                <mat-option [value]="table.value">{{table.viewValue}}</mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>


                </div>

            </div>

            <div class="flex items-center justify-end mt-[5px] mr-2">
                <button class="ml-4 min-w-[120px] w-[100%] sm:w-auto sm:mt-[0px] top-[35px]" mat-flat-button
                    [color]="'primary'" (click)="pageNumber = 0; fetchData()">
                    <mat-icon [svgIcon]="'heroicons_solid:search'"></mat-icon>
                    <span class="ml-2 mr-1 block">Leita</span>
                </button>
            </div>
        </form>
    </div>

    <ng-container>
        <div>
            <div class="flex flex-wrap -m-2 mt-10 justify-center">
                <table mat-table matSort #sortContributionsParent="matSort" [dataSource]="dataSource"
                    (matSortChange)="sortData($event)" class="w-full table-expandable">
                    <ng-container matColumnDef="rulingNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header="rulingNumber">Númer úrskurðar</th>
                        <td mat-cell *matCellDef="let element"> {{ element.rulingNumber }} </td>
                    </ng-container>
                    <ng-container matColumnDef="paymentTransactionTypeAcronym">
                        <th mat-header-cell *matHeaderCellDef>Tegund úrskurðar</th>
                        <td mat-cell *matCellDef="let element"> {{ element.paymentTransactionTypeAcronym}} </td>
                    </ng-container>
                    <ng-container matColumnDef="receiverSSN">
                        <th mat-header-cell *matHeaderCellDef>Kennitala</th>
                        <td mat-cell *matCellDef="let element"> {{element.receiverSSN}} </td>
                    </ng-container>
                    <ng-container matColumnDef="jaRatio">
                        <th mat-header-cell *matHeaderCellDef>JA %</th>
                        <td mat-cell *matCellDef="let element"> {{ localeService.localizeNumber(element.jaRatio,
                            'decimal', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="atRatio">
                        <th mat-header-cell *matHeaderCellDef>AT %</th>
                        <td mat-cell *matCellDef="let element"> {{ localeService.localizeNumber(element.atRatio,
                            'decimal', { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) }}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="divisionOfRulingStatus">
                        <th mat-header-cell *matHeaderCellDef>Staða</th>
                        <td mat-cell *matCellDef="let element"> {{ element.divisionOfRulingStatus }} </td>
                    </ng-container>
                    <ng-container matColumnDef="divisionOfRulingChanged">
                        <th mat-header-cell *matHeaderCellDef>Útreikningi breytt</th>
                        <td mat-cell *matCellDef="let element">
                            <span *ngIf="element.divisionOfRulingChanged">Já</span>
                            <span *ngIf="!element.divisionOfRulingChanged"></span>
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                    <tr class="hover:opacity-70 hover:cursor-pointer" mat-row
                        *matRowDef="let logrow; columns: tableColumns" (click)="viewDivisionOfRulingDetails(logrow)">
                    </tr>
                </table>
            </div>
            <mat-paginator #paginator id="rulingsPaginator" [length]="totalData" [pageSizeOptions]="pageSizes"
                [pageSize]="pageSize" (page)="pageChanged($event)" showFirstLastButtons>
            </mat-paginator>
        </div>
        <div *ngIf="totalData == 0 && !isLoading"
            class="flex flex-col flex-auto items-center justify-center p-6 sm:p-10">
            <div
                class="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">
                Engin skráning fannst</div>
            <div class="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-secondary">Engin skráning
                fannst undir völdu leitarskilyrði</div>
        </div>
    </ng-container>
</div>